import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { MediaItem } from '@dozuki/web-js/components';

export type listUserMediaResult = {
   items: MediaItem[];
};

export function listUserMedia({ ...common }: CommonRequestOptions): Promise<listUserMediaResult> {
   return makeRequest('get', 'user/media/current', {
      ...common,
   });
}
